import * as React from 'react';
import { InputFieldChangeDelegate } from '../../models/InputFieldChangeDelegate';
import './TermsAndConditionsField.scss';
import CheckboxSvg from '../../svg/CheckboxSvg';
import { childClassClosure, ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { RouterLinkProps } from '../../pluggables';

const baseClass = 'terms-conditions-field';
const childClass = childClassClosure(baseClass);


type Props = ClassableProps & {
  value: boolean;
  onChange: InputFieldChangeDelegate<boolean>;
  name?: string;
  labelText?: string;
  linkComponent: React.ComponentClass<RouterLinkProps, {}>;
}

const TermsAndConditionsField: React.FunctionComponent<Props> = props => {
  const fieldName = props.name || 'termsAndConditions';
    return <div className={`field ${baseClassAnd(baseClass, props)}`}>
      <div className={childClass('control-wrapper')}>
        <label htmlFor={fieldName} className={childClass('checkbox-label')}>
          <input id={fieldName} 
                  type='checkbox'
                  name={fieldName}
                  className={childClass('checkbox-invisible')}
                  onChange={e => props.onChange(fieldName, e.currentTarget.checked)}
                  checked={props.value}
                  required />
          <div className='checkbox-svg-wrapper'>
            <CheckboxSvg />
          </div>
          <span>I Accept the </span>
        </label>
        <props.linkComponent className={childClass('checkbox-afterlink')} to={'/terms-and-conditions'}>Terms And Conditions</props.linkComponent>
      </div>
    </div>
}

export default TermsAndConditionsField;